let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kaj6V")).then(() => parcelRequire('50Sy5'));